export const getToken = new Promise((resolve, reject) => {
    const accessToken = localStorage.getItem('accessToken');
   if (accessToken) {
    resolve(accessToken);
   }else {
    reject('Token not found')
   }  
}).catch((err) => {
    console.log(err);
})